// src/components/JoinExperts.js
import React from "react";
import { Link } from "react-router-dom";
import "./JoinExperts.css";

const BASE = process.env.PUBLIC_URL || "landing-page";

export default function JoinExperts() {
  const ARROW = `${BASE}/assets/arrowIcon.png`;

  return (
    <section className="join" dir="ltr" aria-labelledby="join-title">
      <div className="join__inner">
        {/* Content (RTL) */}
        <div className="join__content" dir="rtl">
          <h2 id="join-title" className="join__title">
            انضمّ إلى <span>فريق المختصّين</span>
          </h2>

          <p className="join__lead">
            في "تحرر" نؤمن أنّ التغيير الحقيقي يبدأ من تواصل إنساني صادق.
            لذلك ندعو الأخصائيين النفسيين والأطباء المعتمدين للانضمام إلى
            فريقنا. كن جزءًا من تطبيق يسهّل وصول الدعم النفسي لمجتمع واسع
            ويمنحك منصة لمشاركة خبراتك بشكل مؤثر.
          </p>

          <ul className="join__list">
            <li>
              <i aria-hidden>
                <span><img className="arrowIcon" src={ARROW} alt="" /></span>
              </i>
              الوصول إلى قاعدة مستخدمين متزايدة تبحث عن الدعم النفسي.
            </li>
            <li>
              <i aria-hidden>
                <span><img className="arrowIcon" src={ARROW} alt="" /></span>
              </i>
              أدوات تفاعلية تساعدك على متابعة وتطوير خطط علاجية فعّالة.
            </li>
            <li>
              <i aria-hidden>
                <span><img className="arrowIcon" src={ARROW} alt="" /></span>
              </i>
              بيئة مرنة تُمكّنك من تقديم الاستشارات من أي مكان.
            </li>
            <li>
              <i aria-hidden>
                <span><img className="arrowIcon" src={ARROW} alt="" /></span>
              </i>
              شراكة مع فريق ملتزم بتحقيق جودة حياة أفضل للمستخدمين.
            </li>
          </ul>

          <Link to="/apply" className="join__cta" aria-label="قدّم الآن كأخصائي">
            <span className="join__ctaIcon" aria-hidden>✨</span>
            <span className="join__ctaText">قدّم الآن كأخصائي</span>
          </Link>
        </div>

        {/* Art (decorative overlays) */}
        <div className="join__art" aria-hidden="true">
          <img className="join__rings"   src={`${BASE}/assets/rings.png`}   alt="" loading="lazy" decoding="async" />
          <img className="join__phones"  src={`${BASE}/assets/phones.png`}  alt="" loading="lazy" decoding="async" />
          <img className="join__badge"   src={`${BASE}/assets/badge.png`}   alt="" loading="lazy" decoding="async" />
          <img className="join__profits" src={`${BASE}/assets/profits.png`} alt="" loading="lazy" decoding="async" />
        </div>
      </div>
    </section>
  );
}
